package org.hs_soft.runmynesto.pages.home.sub_page.customer_card.components.tabs.customer_card_tab.component.periods.component

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.margin
import org.hs_soft.runmynesto.domain.config.Dimen
import org.hs_soft.runmynesto.domain.model.general.WindowSizeModeEnum
import org.hs_soft.runmynesto.domain.model.home.customer_card.tabs.card.PeriodDaysEnum
import org.hs_soft.runmynesto.pages.components.CustomRadioInput
import org.jetbrains.compose.web.ExperimentalComposeWebApi
import org.jetbrains.compose.web.dom.RadioGroup

@OptIn(ExperimentalComposeWebApi::class)
@Composable
fun PeriodDays(
    selectedPeriodType: PeriodDaysEnum?,
    onSelectPeriodType: (PeriodDaysEnum) -> Unit,
    windowSizeMode: WindowSizeModeEnum
) {
    val chunk=when(windowSizeMode){
        WindowSizeModeEnum.Desktop->4
        else ->2
    }

    Column(modifier = Modifier)
    {
        RadioGroup(selectedPeriodType?.title) {
            PeriodDaysEnum.entries.chunked(chunk).forEach { filter ->
                Row()
                {
                    filter.forEach { row->
                        Row(
                            verticalAlignment = Alignment.CenterVertically,
                            modifier = Modifier.margin(topBottom = Dimen.smallPadding)
                        )
                        {
                            CustomRadioInput(
                                modifier = Modifier.margin(right = Dimen.normalPadding),
                                title = row.title,
                                checked = row==selectedPeriodType,
                                onClick = {
                                    if (row != selectedPeriodType)
                                        onSelectPeriodType(row)
                                },

                            )
                        }
                    }
                }




            }
        }


    }
}